import { helpers, ts } from '_core';

export const summaryColumns = [
  {
    key: 'metric',
    name: '',
    formatter: helpers.tabularFormatters.formatTo('string', { align: 'left' }),
    filter: 'string',
  },
  {
    key: 'long',
    name: 'Long',
    formatter: helpers.tabularFormatters.formatTo('string', { align: 'right', showBlanks: true }),
    filter: 'number',
  },
  {
    key: 'short',
    name: 'Short',
    formatter: helpers.tabularFormatters.formatTo('string', { align: 'right', showBlanks: true }),
    filter: 'number',
  },
  {
    key: 'value',
    name: 'Total',
    formatter: helpers.tabularFormatters.formatTo('string', { align: 'right' }),
    filter: 'number',
  },
] as ts.types.components.dataGrid.ColumnsData;
